import React from 'react';
import { Crown, Rocket, UserCheck } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface AddOn {
  name: string;
  icon: typeof Crown;
  summary: string;
  points: string[];
  goodFor: string;
}
const addOns: AddOn[] = [{
  name: 'LEADERSHIP',
  icon: Crown,
  summary: 'A dedicated campaign for the operators who scale your team, not the reps who fill it.',
  points: ['Targeted campaigns for proven field operators', 'Executive interviews handled for you', 'Compensation and role benchmarking', 'Priced monthly while the leader stays active'],
  goodFor: 'Good for teams that have rep flow but no one to own the field and drive the numbers.'
}, {
  name: 'CORPORATE RECRUITER',
  icon: UserCheck,
  summary: 'A dedicated recruiter on our side, aligned to your ICP, owning the pipeline end to end.',
  points: ['Aligned to your ICP and hiring standards', 'Owns outreach, screening, and scheduling', 'Scales with your ad spend under management', 'Added to the monthly service'],
  goodFor: 'Good for teams that have the pipeline but not the internal capacity to work it fast enough.'
}, {
  name: 'GO TO MARKET',
  icon: Rocket,
  summary: 'We build your door-to-door channel from zero: the infrastructure, the leader, and the team.',
  points: ['Comp plans, CRM, onboarding, scripts, and KPI dashboards', 'We recruit the field sales leader who owns it', 'The rep pipeline behind 5,000+ D2D hires', 'Sequenced to gain traction in the first quarter'],
  goodFor: 'Good for teams that are new to door-to-door and want it built right the first time.'
}];
export function Slide7_Tiers() {
  return <SlideLayout data-id="element-528" data-mp="36r3snahbglmu">
      <div className="flex flex-col h-full justify-center space-y-8" data-id="element-529" data-mp="36sonl17jm6l8">
        <div className="space-y-3 text-center" data-id="element-530" data-mp="31ssi0xj7673k">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-531" data-mp="31u3m6ygk1gv7">
            Add-Ons
          </h2>
          <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-532" data-mp="15rh1j9dqgx7c">
            Advantage is the system. These layer on when a specific bottleneck
            shows up.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-7xl mx-auto w-full items-stretch" data-id="element-533" data-mp="1es6r3vcehrcm">
          {addOns.map(addOn => {
          const Icon = addOn.icon;
          return <article key={addOn.name} className="flex flex-col rounded-2xl border border-slate-700/60 bg-slate-900/40 p-7" data-id="element-534" data-mp="1om5qiml3ax0v">
                <div className="flex items-center gap-3.5 mb-4" data-id="element-535" data-mp="1yel9nn84hrnc">
                  <div className="p-2.5 rounded-lg bg-slate-800 border border-slate-700" aria-hidden="true" data-id="element-536" data-mp="22fws98skxcm1">
                    <Icon className="w-6 h-6 text-[#7FE0C3]" data-id="element-537" data-mp="2cduejqqvozc0" />
                  </div>
                  <h3 className="text-xl font-bold text-white leading-tight" data-id="element-538" data-mp="2cbqa97p2hyb7">
                    {addOn.name}
                  </h3>
                </div>

                <p className="text-base text-slate-300 leading-snug mb-5 lg:min-h-[4.5rem]" data-id="element-539" data-mp="2hhn3dyg4pzll">
                  {addOn.summary}
                </p>

                <ul className="space-y-2.5 pt-5 border-t border-slate-700/50" data-id="element-540" data-mp="2cletazgsgwla">
                  {addOn.points.map(point => <li key={point} className="flex items-start" data-id="element-541" data-mp="358siuci5qpvd">
                      <span className="mr-3 mt-2 h-1.5 w-1.5 rounded-full shrink-0 bg-[#7FE0C3]" aria-hidden="true" data-id="element-542" data-mp="35a3lg8zv9rkw" />
                      <span className="text-sm text-slate-400 leading-snug" data-id="element-543" data-mp="2vgd21iilk7c2">
                        {point}
                      </span>
                    </li>)}
                </ul>

                <p className="mt-auto pt-6 text-sm font-medium text-[#7FE0C3] leading-snug" data-id="element-544" data-mp="3o0v4y3dkiyd0">
                  {addOn.goodFor}
                </p>
              </article>;
        })}
        </div>
      </div>
    </SlideLayout>;
}